<template>
  <table cellspacing="0" border="1" :class="$style['report-deliver']">
    <tr>
      <td rowspan="3" class="first-line">报告交付</td>
      <td class="seconed-line">交付方式</td>
      <td colspan="4">{{ data.delivery_type }}</td>
    </tr>
    <tr>
      <td class="seconed-line">报告份数</td>
      <td class="report-number" colspan="2">{{ data.reportNum }}</td>
      <td rowspan="2" class="fourth-line">样品处置要求</td>
      <td rowspan="2">
        <checkbox
          :data="sampleHandle"
          :value="back"
          :disabled="true"
        ></checkbox>
      </td>
    </tr>
    <tr>
      <td class="seconed-line">交付日期</td>
      <td colspan="2">{{ data.delivery_date }}</td>
    </tr>

    <tr>
      <td rowspan="3" class="first-line">费用</td>
      <td class="seconed-line">检验检测费（元）</td>
      <td class="examin-fee">{{cost.examinationAmount}}</td>
      <td class="seconed-line">加急费（元）</td>
      <td colspan="2">{{cost.emergencyAmount}}</td>
    </tr>
    <tr>
      <td>合计（元）</td>
      <td class="examin-fee">{{cost.amount}}</td>
      <td>预收费（元）</td>
      <td colspan="2">--</td>
    </tr>
    <tr>
      <td>其他</td>
      <td colspan="4">{{cost.other||'--'}}</td>
    </tr>
    <tr>
      <td colspan="2">备注</td>
      <td colspan="4" class="report-remark">{{cost.remark}}</td>
    </tr>
  </table>
</template>
<script>
import checkbox from "base/checkbox";
import { sampleHandle } from "./report-options";
export default {
  components: {
    checkbox,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
		},
		cost:Object
  },
  data() {
    return {
      sampleHandle: sampleHandle,
    };
  },
  computed: {
    back() {
      return [this.data.back + ""];
    },
  },
};
</script>
<style module lang="less">
.report-deliver {
  font-size: 13px;
  :global {
    .first-line {
      width: 1em;
    }
    .seconed-line {
      width: 7em;
      text-align: center;
    }
    .fourth-line {
      width: 4em;
    }
    .report-number {
      width: 35%;
    }
    .examin-fee {
      width: 35%;
    }
    .report-remark{
      text-align: left;
    }
  }
}
</style>
